import { NgModule } from '@angular/core';
import { FooterComponent } from './footer/footer';
import { IonicModule, IonicPageModule } from 'ionic-angular';
import { BannerComponent } from './banner/banner';
import { PromocionalComponent } from './promocional/promocional';
import { SucursalComponent } from './sucursal/sucursal';
import { PipesModule } from '../pipes/pipes.module';
import { HeaderComponent } from './header/header';
import { ProductoComponent } from './producto/producto';
import { SubheaderComponent } from './subheader/subheader';
import { CarritoBotonComponent } from './carrito-boton/carrito-boton';
import { CarritoProductoComponent } from './carrito-producto/carrito-producto';
import { AdminBotonEditarComponent } from './admin-boton-editar/admin-boton-editar';
import { AdminBotonBorrarComponent } from './admin-boton-borrar/admin-boton-borrar';
@NgModule({
  declarations: [
    FooterComponent,
    BannerComponent,
    PromocionalComponent,
    SucursalComponent,
    HeaderComponent,
    ProductoComponent,
    SubheaderComponent,
    CarritoBotonComponent,
    CarritoProductoComponent,
    AdminBotonEditarComponent,
    AdminBotonBorrarComponent
  ],
  imports: [IonicModule, PipesModule],
  exports: [
    FooterComponent,
    BannerComponent,
    PromocionalComponent,
    SucursalComponent,
    HeaderComponent,
    ProductoComponent,
    SubheaderComponent,
    CarritoBotonComponent,
    CarritoProductoComponent,
    AdminBotonEditarComponent,
    AdminBotonBorrarComponent
  ]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts